import type { Integration } from '../../../types/api';
import { FormField, FormLabel, FormInput } from '../../ui';

interface HubsoftTabProps {
  integration: Integration | null;
}

function HubsoftTab({ integration }: HubsoftTabProps) {
  return (
    <div className="space-y-6">
      <FormField>
        <FormLabel htmlFor="hubsoft_url">URL Hubsoft</FormLabel>
        <FormInput id="hubsoft_url" name="hubsoft_url" defaultValue={integration?.hubsoft_url} />
      </FormField>

      <div className="grid grid-cols-2 gap-4">
        <FormField>
          <FormLabel htmlFor="hubsoft_client_id">Client ID</FormLabel>
          <FormInput
            type="number"
            id="hubsoft_client_id"
            name="hubsoft_client_id"
            defaultValue={integration?.hubsoft_client_id}
          />
        </FormField>

        <FormField>
          <FormLabel htmlFor="hubsoft_client_secret">Client Secret</FormLabel>
          <FormInput
            type="password"
            id="hubsoft_client_secret"
            name="hubsoft_client_secret"
            defaultValue={integration?.hubsoft_client_secret}
          />
        </FormField>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <FormField>
          <FormLabel htmlFor="hubsoft_username">Usuário</FormLabel>
          <FormInput
            id="hubsoft_username"
            name="hubsoft_username"
            defaultValue={integration?.hubsoft_username}
          />
        </FormField>

        <FormField>
          <FormLabel htmlFor="hubsoft_password">Senha</FormLabel>
          <FormInput
            type="password"
            id="hubsoft_password"
            name="hubsoft_password"
            defaultValue={integration?.hubsoft_password}
          />
        </FormField>
      </div>

      <FormField>
        <FormLabel htmlFor="hubsoft_token">Token de Acesso</FormLabel>
        <FormInput
          id="hubsoft_token"
          name="hubsoft_token"
          defaultValue={integration?.hubsoft_token}
          placeholder="Token será gerado automaticamente"
        />
      </FormField>

      <FormField>
        <FormLabel htmlFor="hubsoft_id_tipo_atendimento">ID Tipo de Atendimento</FormLabel>
        <FormInput
          type="number"
          id="hubsoft_id_tipo_atendimento"
          name="hubsoft_id_tipo_atendimento"
          defaultValue={integration?.hubsoft_id_tipo_atendimento}
        />
      </FormField>
    </div>
  );
}

export default HubsoftTab;
